<template>
  <div>
    <v-row class="grey lighten-2 my-4 weekdays">
      <v-col cols="2">
        <span>Thứ 2</span>
      </v-col>
      <v-col cols="2">
        <span>Thứ 3</span>
      </v-col>
      <v-col cols="2">
        <span>Thứ 4</span>
      </v-col>
      <v-col cols="2">
        <span>Thứ 5</span>
      </v-col>
      <v-col cols="2">
        <span>Thứ 6</span>
      </v-col>
      <v-col cols="2">
        <span>Thứ 7</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <AutocompleteBusStop
          v-model="mondayBusStop"
          label="Điểm dừng"
          outlined
          dense
          :filters="{
            bus: busId,
            'busSchedule.dayOfWeek': 'monday',
            'busSchedule.direction': direction,
            'busSchedule.periodTime': periodTime
          }"
        />
      </v-col>
      <v-col cols="2">
        <AutocompleteBusStop
          v-model="tuesdayBusStop"
          label="Điểm dừng"
          outlined
          dense
          :filters="{
            bus: busId,
            'busSchedule.dayOfWeek': 'tuesday',
            'busSchedule.direction': direction,
            'busSchedule.periodTime': periodTime
          }"
        />
      </v-col>
      <v-col cols="2">
        <AutocompleteBusStop
          v-model="wednesdayBusStop"
          label="Điểm dừng"
          outlined
          dense
          :filters="{
            bus: busId,
            'busSchedule.dayOfWeek': 'wednesday',
            'busSchedule.direction': direction,
            'busSchedule.periodTime': periodTime
          }"
        />
      </v-col>
      <v-col cols="2">
        <AutocompleteBusStop
          v-model="thursdayBusStop"
          label="Điểm dừng"
          outlined
          dense
          :filters="{
            bus: busId,
            'busSchedule.dayOfWeek': 'thursday',
            'busSchedule.direction': direction,
            'busSchedule.periodTime': periodTime
          }"
        />
      </v-col>
      <v-col cols="2">
        <AutocompleteBusStop
          v-model="fridayBusStop"
          label="Điểm dừng"
          outlined
          dense
          :filters="{
            bus: busId,
            'busSchedule.dayOfWeek': 'friday',
            'busSchedule.direction': direction,
            'busSchedule.periodTime': periodTime
          }"
        />
      </v-col>
      <v-col cols="2">
        <AutocompleteBusStop
          v-model="saturdayBusStop"
          label="Điểm dừng"
          outlined
          dense
          :filters="{
            bus: busId,
            'busSchedule.dayOfWeek': 'saturday',
            'busSchedule.direction': direction,
            'busSchedule.periodTime': periodTime
          }"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AutocompleteBusStop from '@/components/basic/input/AutocompleteBusStop.vue'

export default {
  components: {
    AutocompleteBusStop
  },
  props: {
    busId: {
      type: String,
      required: true,
      default: () => ''
    },
    direction: {
      type: String,
      required: true,
      default: () => ''
    },
    periodTime: {
      type: String,
      required: true,
      default: () => ''
    }
  },
  data() {
    return {
      loading: false,
      originHeaders: [
        {
          text: 'Thứ Hai',
          value: 'monday',
          align: 'left',
          sortable: false
        },
        {
          text: 'Thứ Ba',
          value: 'tuesday',
          align: 'left',
          sortable: false
        },
        {
          text: 'Thứ Tư',
          value: 'wednesday',
          align: 'left',
          sortable: false
        },
        {
          text: 'Thứ Năm',
          value: 'thursday',
          align: 'left',
          sortable: false
        },
        {
          text: 'Thứ Sáu',
          value: 'friday',
          align: 'left',
          sortable: false
        },
        {
          text: 'Thứ Bảy',
          value: 'saturday',
          align: 'left',
          sortable: false
        }
      ],
      items: [{}],
      mondayBusStop: null,
      tuesdayBusStop: null,
      wednesdayBusStop: null,
      thursdayBusStop: null,
      fridayBusStop: null,
      saturdayBusStop: null
    }
  },

  methods: {
    getData() {
      const busStops = []
      this.mondayBusStop && busStops.push(this.mondayBusStop)
      this.tuesdayBusStop && busStops.push(this.tuesdayBusStop)
      this.wednesdayBusStop && busStops.push(this.wednesdayBusStop)
      this.thursdayBusStop && busStops.push(this.thursdayBusStop)
      this.fridayBusStop && busStops.push(this.fridayBusStop)
      this.saturdayBusStop && busStops.push(this.saturdayBusStop)
      return busStops
    }
  },
  computed: {}
}
</script>

<style scoped>
.weekdays {
  width: 100%;
  margin: 0;
  font-size: 16px;
}
</style>
